var map = {
	"./affinity.png": 2562,
	"./aip5.png": 9535,
	"./analytics.png": 6424,
	"./aurelia.png": 7735,
	"./axelssondev.png": 4602,
	"./axelssondev2.png": 3128,
	"./barchart.png": 7138,
	"./brackets.png": 5490,
	"./carboncal3.png": 8761,
	"./carboncal4.png": 2246,
	"./css.png": 1262,
	"./cv1.pdf": 6345,
	"./ecom2.png": 5993,
	"./electron.png": 3921,
	"./festprissen.png": 9094,
	"./figma.png": 4458,
	"./frontend2.png": 2473,
	"./github.png": 6368,
	"./html.png": 80,
	"./hubso.png": 4078,
	"./illustration.png": 1001,
	"./illustration2.png": 988,
	"./java.png": 5062,
	"./kejbertconcept.png": 9944,
	"./klaviyo4.png": 8769,
	"./kthlogga.svg": 7361,
	"./kthlogga2.png": 6999,
	"./lecap.png": 3296,
	"./lecap2.png": 1325,
	"./lxa.png": 635,
	"./lxa2.png": 9739,
	"./map.png": 7644,
	"./map2.png": 8703,
	"./netlify.png": 9644,
	"./nextjs.png": 7656,
	"./philip.jpg": 5791,
	"./philip6.png": 1251,
	"./philip8.png": 2717,
	"./photoshop1.png": 1942,
	"./postman.png": 884,
	"./python.png": 4720,
	"./react2.png": 6352,
	"./sanity.png": 753,
	"./sann2.png": 7063,
	"./sanne.png": 6277,
	"./shopify.png": 6858,
	"./shopifylogo.png": 8292,
	"./uxui.png": 7524,
	"./vscode.png": 2880,
	"./woo.png": 8858,
	"./wordpress.png": 4034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5160;